var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3072 5.32665L12.7738 8.82976C12.3816 9.2186 11.7484 9.21587 11.3596 8.82367L7.85649 5.29031C7.46765 4.89811 6.83449 4.89539 6.44229 5.28423L5.38575 6.33172C4.99355 6.72056 4.99083 7.35372 5.37967 7.74592L8.88277 11.2793C9.27161 11.6715 9.26889 12.3046 8.87669 12.6935L5.34333 16.1966C4.95113 16.5854 4.9484 17.2186 5.33724 17.6108L6.38474 18.6673C6.77358 19.0595 7.40674 19.0623 7.79894 18.6734L11.3323 15.1703C11.7245 14.7815 12.3577 14.7842 12.7465 15.1764L16.2496 18.7098C16.6384 19.102 17.2716 19.1047 17.6638 18.7158L18.7203 17.6683C19.1125 17.2795 19.1153 16.6463 18.7264 16.2541L15.2233 12.7208C14.8345 12.3286 14.8372 11.6954 15.2294 11.3066L18.7628 7.80347C19.155 7.41463 19.1577 6.78147 18.7689 6.38928L17.7214 5.33273C17.3325 4.94053 16.6994 4.93781 16.3072 5.32665Z",
    stroke: "#53514D",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.784f0bbcc7b85ffe8bd0931b997fd885.svg";
export { ForwardRef as ReactComponent };